module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      'opac': _vm.isOpac
    },
    staticStyle: {
      "-moz-user-select": "none",
      "-ms-user-select": "none",
      "-webkit-user-select": "none",
      "cursor": "pointer"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "canvas1",
      "width": "800",
      "height": "60"
    }
  }, [_vm._v("Your browser does not support the canvas element.")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvas3",
      "width": "800",
      "height": "60"
    }
  }, [_vm._v("Your browser does not support the canvas element.")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvas2",
      "width": "800",
      "height": "60"
    },
    on: {
      "mousedown": _vm.handleMouseDown
    }
  }, [_vm._v("Your browser does not support the canvas element.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-237feda6","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/vehicletrace/VehicleAxis.vue
// module id = 1442
// module chunks = 0